import { ColumnDef } from "@tanstack/react-table";
import Table from "@via/components/table/table.tsx";
import {
  cleanTabularDataBeforeRender,
  customSortingFn,
  findType,
  getColumnsTabularData,
} from "@via/pages/projects/runs/reports/utils/helpers.ts";
import { type FC, useEffect, useState } from "react";

interface TabularLogsProps {
  logs: string;
}
const TabularLogs: FC<TabularLogsProps> = ({ logs }) => {
  const [data, setData] = useState<Record<string, unknown>[]>([]);
  const [columns, setColumns] = useState<ColumnDef<any>[]>([]);

  useEffect(() => {
    if (logs) {
      const columns = getColumnsTabularData(logs);
      const rows = cleanTabularDataBeforeRender(logs, columns) as Record<
        string,
        unknown
      >[];
      setColumns(
        columns.map((field: string) => {
          const type = findType((rows?.[0]?.[field] ?? "") as string);
          return {
            size: 150,
            minSize: 100,
            accessorKey: field,
            header: field,
            cell: (info: any) => info.getValue(),
            type,
            sortingFn: customSortingFn(type),
          };
        })
      );
      setData(rows);
    }
  }, [logs]);

  return (
    <Table
      data={data}
      columns={columns}
      showPagination
      total={data?.length || 0}
      enableGlobalFilter
      emptyMessage="No data available"
      applyColumnSize
      customTableClassName="w-max whitespace-nowrap"
    />
  );
};

export default TabularLogs;
